import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, Divider } from 'antd'
import { ObjectiveInput } from '../../../../types'
import { useAmountAndCurrency } from '../../../../shared/useAmountAndCurrency'
import { ViewKeyResults } from '../../../../modules/appraisal/okr/components/ViewKeyResults'
import { Notes } from '../../../../modules/appraisal/okr/components/Notes'
import PerText from '../../Text'
import PerFlexRow from '../../FlexRow'
import './index.less'
import { TimeZoneAndLocale } from '../../../../types.custom'
import PerDatePicker from '../../DatePicker'
import { ObjectiveDownloadButton } from '../../ObjectiveDownload'
import { useCurrency } from '../../../../context/currency-context'

interface ConclusionTargetModalProps {
  objective: ObjectiveInput
  employeeId: string
  user: TimeZoneAndLocale
}

export const ConclusionTargetModal: FC<ConclusionTargetModalProps> = ({ objective, employeeId, user }) => {
  const { formatCurrency } = useAmountAndCurrency(user.locale)
  const [t] = useTranslation()
  const { currency } = useCurrency()

  return (
    <div className="per-conclusionTargetModal">
      <Row align="top">
        <Col span={14}>
          <ViewKeyResults keyResults={objective.keyResults} />
        </Col>
        <Col span={8} offset={2}>
          <PerFlexRow direction="column">
            {objective.targetAmount && (
              <PerFlexRow direction="column" mb="m">
                <PerFlexRow direction="row" justify="space-between" mb="xxs" align="bottom">
                  <PerText appearance="label-small">{t('okr.objective.modal.targetAmount')} </PerText>
                  <PerText>{formatCurrency(objective.targetAmount, currency)}</PerText>
                </PerFlexRow>
              </PerFlexRow>
            )}

            <PerText appearance="label-small" mb="xxxs">
              {t('okr.objective.modal.startDate')}
            </PerText>
            <PerDatePicker
              inputDate={objective.start}
              onDateChanged={() => {
                return
              }}
              timeZoneAndLocale={user}
              dateFormat="DMY"
              disabled
            />

            <PerText appearance="label-small" mt="s" mb="xxxs">
              {t('okr.objective.modal.dueDate')}
            </PerText>
            <PerDatePicker
              inputDate={objective.due}
              onDateChanged={() => {
                return
              }}
              timeZoneAndLocale={user}
              dateFormat="DMY"
              disabled
            />

            {objective.attachment && (
              <>
                <PerText appearance="label-small" mt="s" mb="xxxs">
                  {t('appraisalMeeting.closedTargetsOverview.item.attachment')}{' '}
                </PerText>
                <ObjectiveDownloadButton employeeIdOfMeetingNotLoggedInEmployeeId={employeeId} objective={objective} />
              </>
            )}
          </PerFlexRow>
        </Col>
      </Row>

      {objective.noteList && !!objective.noteList.length && (
        <>
          <Divider />
          <Notes objective={{ ...objective }} editable={false} />
        </>
      )}
    </div>
  )
}
